import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import {  Grid, Link, InputLabel, Select, MenuItem, FormControl } from "@mui/material";
import { useState } from "react";
import Button from 'react-bootstrap/Button';
import { MobileStepper } from '@mui/material';
import NumericInput from "react-numeric-input";
import { collection, getCountFromServer, getFirestore, onSnapshot, getDocs, query, where } from '@firebase/firestore';
import {  db } from "./firebase";
import { useCollectionData } from "react-firebase-hooks/firestore";
import { useAuth } from "./authContext";
import { doc, setDoc } from "firebase/firestore"; 
import {
  Unstable_NumberInput as BaseNumberInput,
  NumberInputProps,
} from '@mui/base/Unstable_NumberInput';
import { styled } from '@mui/system';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';


function createData(
  name,
  calories,
  fat,
  carbs,
  protein
) {
  return { name, calories, fat, carbs, protein };
}

const NumberInput = React.forwardRef(function CustomNumberInput(
  props,ref
) {
  return (
    <BaseNumberInput
      slots={{
        root: StyledInputRoot,
        input: StyledInput,
        incrementButton: StyledButton,
        decrementButton: StyledButton,
      }}
      slotProps={{
        incrementButton: {
          children: <AddIcon fontSize="small" />,
          className: 'increment',
        },
        decrementButton: {
          children: <RemoveIcon fontSize="small" />,
        },
      }}
      {...props}
      ref={ref}
    />
  );
});

const rows = [
  createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
  createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
  createData('Eclair', 262, 16.0, 24, 6.0),
  createData('Cupcake', 305, 3.7, 67, 4.3),
  createData('Gingerbread', 356, 16.0, 49, 3.9),
];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  marginTop:'30px',
  marginBottom:'30px',

  borderRadius:3,
  transform: "translate(-50%, -50%)",
  width: '1100px',
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  maxHeight: '100vh',
  p: 4,
  overflowY: "auto"
};

const blue = {
  100: '#daecff',
  200: '#b6daff',
  300: '#66b2ff',
  400: '#3399ff',
  500: '#007fff',
  600: '#0072e5',
  700: '#0059B2',
  800: '#004c99',
};

const grey = {
  50: '#F3F6F9',
  100: '#E5EAF2',
  200: '#DAE2ED',
  300: '#C7D0DD',
  400: '#B0B8C4',
  500: '#9DA8B7',
  600: '#6B7A90',
  700: '#434D5B',
  800: '#303740',
  900: '#1C2025',
};



export default function NewPatientModal2({ onOpen, onClose, open, row }) {


  const [propertyName, setPropertyName] = useState('');
  const [currentRent, setCurrentRent] = useState(0);
  const [marketRent, setMarketRent] = useState(0);
  const [purchasePrice, setPurchasePrice] = useState(0);
  const [downPaymentPercentage, setDownPaymentPercentage] = useState(0);
  const [interestRate, setInterestRate] = useState(0);
  const [term, setTerm] = useState(0);
  const [nickname, setNickname] = useState('');
  const [monthlyMaintainenceReservation, setMonthlyMaintainenceReservation] = useState(0);
  const [monthlyVacancyReserve, setMonthlyVacancyReserve] = useState(0);
  const [monthlyUtilities, setMonthlyUtilities] = useState(0);


  const { currentUser } = useAuth()



  function setDelay() { 
    setTimeout( window.location = 'dealcalculator', 2000)
}
 
  
  const addManualUser = (event) => {
    event.preventDefault();
    var uniqueID = Math.random().toString(16).slice(2)
    setDoc(doc(db, "users", currentUser.uid, "properties" ,uniqueID), {
       propertyName,
      currentRent, 
      marketRent, 
      purchasePrice, 
      downPaymentPercentage, 
      interestRate, 
      totalDownPayment,
      term, 
      nickname,
      monthlyUtilities,
      monthlyVacancyReserve,
      monthlyMaintainenceReservation
    }, {merge:true}).then(setDelay);
// ;
    
  }

  ///////////PROPERTY TAXES///////////////////

  let propertyTaxOperatingCost = Math.round(purchasePrice * .000925)
  let insuranceOperatingCost = Math.round(purchasePrice * .000833)

  let totalDownPayment = (Math.round((downPaymentPercentage*.01) *purchasePrice))
  ///////////PROPERTY TAXES///////////////////

/////////////PROPERTY MANAGEMENT//////////
const totalPropManagement = currentRent *.1
const potentialTotalPropManagement = marketRent *.1

/////////////PROPERTY MANAGEMENT//////////

    //////////MORTGAGE CALCULATOR ////////////////

    
    var M; //monthly mortgage payment
    var P = purchasePrice * (1 - (downPaymentPercentage*.01)); //principle / initial amount borrowed
    var I = interestRate / 100 / 12; //monthly interest rate
    var N = term * 12; //number of payments months  

    function monthlyPayment(p, n, i) {
      return p * i * (Math.pow(1 + i, n)) / (Math.pow(1 + i, n) - 1);
    }

    M = monthlyPayment(P, N, I);
    




    //////////MORTGAGE CALCULATOR ////////////////

  ////////TOTAL MONTHLY EXPENSE//////////////
  let totalMonthlyExpense = (totalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation+Math.round(monthlyPayment(P,N,I)))
  let potentialTotalMonthlyExpense = (potentialTotalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation+Math.round(monthlyPayment(P,N,I)))
  console.log(totalMonthlyExpense)

  console.log('TME',totalMonthlyExpense )
    ////////TOTAL MONTHLY EXPENSE//////////////
  return (
    <div>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
      
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
           
            <Grid item xs={6}>
            <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ fontWeight: 'bold'}}>
             Address
            <input
                                                        value={propertyName} onChange={(e) => { setPropertyName(e.target.value) }}

                                type="text"
                                required
                                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:indigo-600 shadow-sm rounded-lg transition duration-300"
                            />
          </Typography>
            </Grid>
            <Grid item xs={6}>
            <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ fontWeight: 'bold'}}>
              Property Nickname
            <input
                                            value={nickname} onChange={(e) => { setNickname(e.target.value) }}

                                type="text"
                                required
                                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:indigo-600 shadow-sm rounded-lg transition duration-300"
                            />
          </Typography>
            </Grid>
            <Grid item xs={6}>
            <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ fontWeight: 'bold'}}>
              Current Rent (use for monthly cashflow)
            <input
                                            value={currentRent} onChange={(e) => { setCurrentRent(e.target.value) }}

                                type="text"
                                required
                                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:indigo-600 shadow-sm rounded-lg transition duration-300"
                            />
          </Typography>
            </Grid>
            <Grid item xs={6}>
            <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ fontWeight: 'bold'}}>
            Market Rent
            <input
                                type="text"
                                required
                                value={marketRent} onChange={(e) => { setMarketRent(e.target.value) }}

                                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:indigo-600 shadow-sm rounded-lg transition duration-300"
                            />
          </Typography>
            </Grid>
            <Grid item xs={6}>
            <Typography id="modal-modal-title" variant="body1" component="h2">
            {/* {row.firstName} {row.lastName}           */}
            </Typography>
            </Grid>
            <Grid item xs={6}>
            <Typography id="modal-modal-title" variant="body1" component="h2">
            {/* {row.email}  */}
          </Typography>
            </Grid>
            <Grid item xs={4}>
            <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ fontWeight: 'bold'}}>
Purchase Price            <input
            value={purchasePrice} onChange={(e) => { setPurchasePrice(e.target.value) }}
                                type="text"
                                required
                                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:indigo-600 shadow-sm rounded-lg transition duration-300"
                            />
          </Typography>
            </Grid>
            <Grid item xs={4}>
            <Typography id="modal-modal-title" sx={{ fontWeight: 'bold'}} variant="h6" component="h2">
            Down Payment (%)
            <input
            value={downPaymentPercentage} onChange={(e) => { setDownPaymentPercentage(e.target.value) }}
                                type="text"
                                required
                                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:indigo-600 shadow-sm rounded-lg transition duration-300"
                            />
          </Typography>
            </Grid>
            <Grid item xs={4}>
            <Typography id="modal-modal-title" sx={{ fontWeight: 'bold'}} variant="h6" component="h2">
            Down Payment
            <input
            value={totalDownPayment } onChange={(e) => { setDownPaymentPercentage(e.target.value) }}
                                type="text"
                                disabled
                                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:indigo-600 shadow-sm rounded-lg transition duration-300"
                            />
          </Typography>
            </Grid>
            <Grid item xs={6}>
            <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ fontWeight: 'bold'}}>
            Interest Rate
            <input
            value={interestRate} onChange={(e) => { setInterestRate(e.target.value) }}
                                type="text"
                                required
                                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:indigo-600 shadow-sm rounded-lg transition duration-300"
                            />
          </Typography>
            </Grid>
            <Grid item xs={6}>
            <Typography id="modal-modal-title" sx={{ fontWeight: 'bold'}} variant="h6" component="h2">
            Term (yrs)
            <input
            value={term} onChange={(e) => { setTerm(e.target.value) }}
                                type="text"
                                required
                                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:indigo-600 shadow-sm rounded-lg transition duration-300"
                            />
          </Typography>
          
            </Grid>
            <Grid item xs={6} align={'center'}>
            <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ fontWeight: 'bold', alignContent:'center'}}>
            Current Financials (Monthly)
            
          </Typography>
            </Grid>
            <Grid item xs={6} align={'center'}>
            <Typography id="modal-modal-title" sx={{ fontWeight: 'bold'}} variant="h6" component="h2">
            Potential Financials (Monthly)
           
          </Typography>
          
            </Grid>



            
      
         {/* Current FInancials */}

        



<Grid container columns={2} >

  <Grid container columns={2} xs={1} sx={{ border: 1, borderRadius:'5px', marginTop:'10px', padding:2}}>
  
  <Grid item xs={1}>
            <Typography id="modal-modal-title"  variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Prop Mgmt</h3>
              <h3 align={'center'}>${totalPropManagement}</h3>
  
          </Typography>
            <Typography 
              id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Prop Taxes</h3>
              <h3 align={'center'}>${(purchasePrice * .000925)}</h3>

          </Typography>
            </Grid>



            <Grid item xs={1} sx={{borderBottom:'1px'}}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}} >Gross Rent</h3>
              <h3 align={'center'}>${currentRent}</h3>
              {/* <h3 align={'center'} style={{fontWeight:'bold'}}>Prop Taxes</h3>
              <h3 align={'center'}>${(purchasePrice * .000925)}</h3> */}
              
          </Typography>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Total Op. Expenses</h3>
              <div align={'center'} >${totalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation}</div>

          </Typography>
            </Grid>

            <Grid item xs={1}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Insurance</h3>
              <h3 align={'center'}>${(purchasePrice * .000833)}</h3>
              
          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
            <h3 align={'center'} style={{fontWeight:'bold'}}>Utilities</h3>
              <NumberInput aria-label="Quantity Input"  style={{marginBottom:'10px'}} min={1} max={100000}   value={monthlyUtilities}
    onChange={(event, val) => setMonthlyUtilities(val)}/>
          </Typography>
            </Grid>

            <Grid item xs={1}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Monthly NOI</h3>
              <div align={'center'} >${currentRent - (totalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation) }</div>
              
          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Annual NOI</h3>
              <div align={'center'} >${(currentRent - (totalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation))*12}</div>

          </Typography>
            </Grid>
            <Grid item xs={1}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Vacancy Reserve</h3>
              <NumberInput style={{marginBottom:'10px'}}aria-label="Quantity Input" min={1} max={100000}   value={monthlyVacancyReserve}
    onChange={(event, val) => setMonthlyVacancyReserve(val)}

/>              
          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Mtc Reserve</h3>
              <NumberInput style={{marginBottom:'10px'}} aria-label="Quantity Input" min={1} max={100000}   value={monthlyMaintainenceReservation}
    onChange={(event, val) => setMonthlyMaintainenceReservation(val)}

/>
          </Typography>
            </Grid>
            <Grid item xs={1}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Cap Rate</h3>
              <div align={'center'} >{((((currentRent - (totalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation))*12)/purchasePrice)*100).toFixed(2)}%</div>
              
          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold', marginTop:'16px'}}>Mortgage</h3>
              <div align={'center'} >${Math.round(monthlyPayment(P,N,I))}</div>

          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold', marginTop:'16px'}}>Monthly Cashflow</h3>
              <div align={'center'} >${currentRent - totalMonthlyExpense}</div>

          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold', marginTop:'16px'}}>Annual Cashflow</h3>
              <div align={'center'} >${(currentRent - totalMonthlyExpense)*12}</div>

          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold', marginTop:'16px'}}>Annualized ROI</h3>
              <div align={'center'} >{(100*(((currentRent - totalMonthlyExpense)*12)/purchasePrice)).toFixed(2)}%</div>

          </Typography>
            </Grid>

</Grid>
  <Grid container columns={2} xs={1} sx={{ border: 1, borderRadius:'5px', marginTop:'10px', padding:2, marginLeft:'0px'}}>
  
  <Grid item xs={1}>
            <Typography id="modal-modal-title"  variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}} >Prop Mgmt</h3>
              <h3 align={'center'}>${potentialTotalPropManagement}</h3>
  
          </Typography>
            <Typography 
              id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Prop Taxes</h3>
              <h3 align={'center'}>${(purchasePrice * .000925)}</h3>

          </Typography>
            </Grid>



            <Grid item xs={1} sx={{borderBottom:'1px'}}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}} >Gross Rent</h3>
              <h3 align={'center'}>${marketRent}</h3>
              {/* <h3 align={'center'} style={{fontWeight:'bold'}}>Prop Taxes</h3>
              <h3 align={'center'}>${(purchasePrice * .000925)}</h3> */}
              
          </Typography>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Total Op. Expenses</h3>
              <div align={'center'} >${potentialTotalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation}</div>

          </Typography>
            </Grid>

            <Grid item xs={1}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Insurance</h3>
              <h3 align={'center'}>${(purchasePrice * .000833)}</h3>
              
          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
            <h3 align={'center'} style={{fontWeight:'bold'}}>Utilities</h3>
              <NumberInput aria-label="Quantity Input"  style={{marginBottom:'10px'}} min={1} max={100000}   value={monthlyUtilities}
    onChange={(event, val) => setMonthlyUtilities(val)}/>
          </Typography>
            </Grid>

            <Grid item xs={1}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Monthly NOI</h3>
              <div align={'center'} >${marketRent - (potentialTotalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation) }</div>
              
          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Annual NOI</h3>
              <div align={'center'} >${(marketRent - (potentialTotalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation))*12}</div>

          </Typography>
            </Grid>
            <Grid item xs={1}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Vacancy Reserve</h3>
              <NumberInput style={{marginBottom:'10px'}}aria-label="Quantity Input" min={1} max={100000}   value={monthlyVacancyReserve}
    onChange={(event, val) => setMonthlyVacancyReserve(val)}

/>              
          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Mtc Reserve</h3>
              <NumberInput style={{marginBottom:'10px'}} aria-label="Quantity Input" min={1} max={100000}   value={monthlyMaintainenceReservation}
    onChange={(event, val) => setMonthlyMaintainenceReservation(val)}

/>
          </Typography>
            </Grid>
            <Grid item xs={1}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Cap Rate</h3>
              <div align={'center'} >{((((marketRent - (potentialTotalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation))*12)/purchasePrice)*100).toFixed(2)}%</div>
              
          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold', marginTop:'16px'}}>Mortgage</h3>
              <div align={'center'} >${Math.round(monthlyPayment(P,N,I))}</div>

          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold', marginTop:'16px'}}>Monthly Cashflow</h3>
              <div align={'center'} >${marketRent - potentialTotalMonthlyExpense}</div>

          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold', marginTop:'16px'}}>Annual Cashflow</h3>
              <div align={'center'} >${(marketRent - potentialTotalMonthlyExpense)*12}</div>

          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold', marginTop:'16px'}}>Annualized ROI</h3>
              <div align={'center'} >{(100*(((marketRent - potentialTotalMonthlyExpense)*12)/purchasePrice)).toFixed(2)}%</div>

          </Typography>
            </Grid>

</Grid>

  


</Grid>



            
                    
            
          </Grid>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
           
            <Grid item xs={6}>
            
          
            </Grid>
            
      

        
          
        
       


            <div style={
{marginLeft:'42%', 


            }}> 
<button onClick={addManualUser} class="bg-transparent hover:bg-green-500 text-green-700 font-semibold hover:text-white py-2 px-4 border border-green-500 hover:border-transparent rounded mt-5">
  Add Property
</button>
</div>

            
            
          
            
            <Grid item xs={6}>
            <Typography id="modal-modal-title" variant="body1" component="h2">
            {/* {row.street} */}
          </Typography>
            </Grid>
            <Grid item xs={6}>
            <Typography id="modal-modal-title" variant="body1" component="h2">
            {/* {row.permission} */}
          </Typography>
            </Grid>
            <Grid item xs={6}>
            <Typography id="modal-modal-title" variant="body1" component="h2">
            {/* {row.city} */}
          </Typography>
            </Grid>
            <Grid item xs={6}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
           
          </Typography>
            </Grid>
            <Grid item xs={6}>
            <Typography id="modal-modal-title" variant="body1" component="h2">
            {/* {row.livingState} */}
          </Typography>
            </Grid>
            <Grid item xs={6}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
           
          </Typography>
            </Grid>
            <Grid item xs={6}>
            <Typography id="modal-modal-title" variant="body1" component="h2">
            {/* {row.zip} */}
          </Typography>
            </Grid>
            <Grid item xs={6}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
          </Typography>
            </Grid>


            
            <Grid item xs={6} >
            <Typography id="modal-modal-title" variant="body1" component="h2">
                  
            </Typography>
            </Grid>
            
            <Grid item xs={6}>
                  
            </Grid>
            <Grid item xs={6}>
                  
            </Grid>
           
            
          
            
            
          </Grid>
          
            
          
      


<div>

      </div>
        </Box>
      
        
      </Modal>
    </div>
  );
}

const StyledInputRoot = styled('div')(
  ({ theme }) => `
  font-family: 'IBM Plex Sans', sans-serif;
  font-weight: 400;
  color: ${theme.palette.mode === 'dark' ? grey[300] : grey[500]};
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
`,
);

const StyledInput = styled('input')(
  ({ theme }) => `
  font-size: 0.875rem;
  font-family: inherit;
  font-weight: 400;
  line-height: 1.375;
  color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
  background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
  border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
  box-shadow: 0 2px 4px ${
    theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
  };
  border-radius: 8px;
  margin: 0 8px;
  padding: 10px 12px;
  outline: 0;
  min-width: 0;
  width: 4rem;
  text-align: center;

  &:hover {
    border-color: ${blue[400]};
  }

  &:focus {
    border-color: ${blue[400]};
    box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[700] : blue[200]};
  }

  &:focus-visible {
    outline: 0;
  }
`,
);



const StyledButton = styled('button')(
  ({ theme }) => `
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 0.875rem;
  box-sizing: border-box;
  line-height: 1.5;
  border: 1px solid;
  border-radius: 999px;
  border-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
  background: ${theme.palette.mode === 'dark' ? grey[900] : grey[50]};
  color: ${theme.palette.mode === 'dark' ? grey[200] : grey[900]};
  width: 32px;
  height: 32px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 120ms;

  &:hover {
    cursor: pointer;
    background: ${theme.palette.mode === 'dark' ? blue[700] : blue[500]};
    border-color: ${theme.palette.mode === 'dark' ? blue[500] : blue[400]};
    color: ${grey[50]};
  }

  &:focus-visible {
    outline: 0;
  }

  &.increment {
    order: 1;
  }
`,
);